<template lang="pug">
 .text-center
  v-dialog(v-model='dialog' scrollable persistent width='900' style="margin-top:-30px")
    v-form(ref="form" v-model="valid" lazy-validation)
      v-card
        v-card-title.text-h5.grey.lighten-2
          | Edit Visitor
          v-btn(icon='' dark='' style=' color:black; position: absolute; right: 0' @click='onClose()')
            v-icon mdi-close
        v-card-text
          v-layout(row, wrap style="margin-top:30px;margin-bottom:-20px")
            v-flex(xs4, sm3)
              p.headerSection 
                span.mustFill *
                span Nama Lengkap
            v-flex(xs7, sm7)
              v-text-field.inputDefault(
                v-model="visitorName",
                label="Nama Lengkap",
                id="evis-nama-lengkap"
                disabled
              )
            v-flex(xs1, sm2)

            v-flex(xs4, sm3)
              p.headerSection 
                span.mustFill *
                span Email
            v-flex(xs7, sm7)
              v-text-field.inputDefault(
                v-model="visitorEmail",
                disabled
                label="Email"
                id="evis-email"
              )
            v-flex(xs1, sm2)

            v-flex(xs4, sm3 style="padding-top:15px")
              p.headerSection 
                span.mustFill *
                span No Handphone
            v-flex(xs7, sm7 style="padding-top:15px")
              v-text-field.inputDefault(
                v-model="visitorPhone",
                label="No Handphone"
                id="evis-nohp"
                maxlength='15'
                counter
                :rules='[visitorRules.required, visitorRules.phone]'
              )
            v-flex(xs1, sm2)

            v-flex(xs4, sm3 style="padding-top:15px")
              p.headerSection 
                span.mustFill *
                span No Darurat
            v-flex(xs7, sm7 style="padding-top:15px")
              v-text-field.inputDefault(
                v-model="visitorEmergency",
                label="No Darurat"
                id="evis-no-darurat"
                maxlength='15'
                counter
                :rules='[visitorRules.required, visitorRules.phone]'
              )
            v-flex(xs1, sm2)
            
            v-flex(xs3, sm3 v-if="errorNotif")
            v-flex(xs9, sm9 v-if="errorNotif" style="margin-top:-15px;margin-bottom:15px")
              label(v-if="errorNotif" style="color:red;text-align:center") {{errorNotif}}
            v-flex(xs4 sm3 style="padding-top:15px") 
              p(class="headerSection") 
                span(class="mustFill") *
                span  Golongan Darah
            v-flex(xs7 sm7 style="padding-top:15px")
              v-autocomplete(
                class="inputDefault"
                id="evis-visitor-blood"
                v-model="visitorBloodType"
                :items="golonganDarahList"
                :rules='[visitorRules.required]'
                label="Golongan Darah")
            v-flex(xs1 sm2)
            
            v-flex(xs4 sm3 style="padding-top:15px")
              p(class="headerSection") 
                span(class="mustFill") *
                span  Nomor KTP
            v-flex(xs7 sm7 style="padding-top:15px")
              v-text-field(class="inputDefault" type="number" 
              id="evis-visitor-ktp"
                v-model='visitorKtp' 
                label="NIK"
                :counter="16"
                :rules="[visitorRules.ktpLength, visitorRules.required]"
              )
            v-flex(xs1 sm2)

            v-flex(xs5 sm3 style="padding-top:15px") 
              p(class="headerSection") 
                span(class="mustFill") *
                span  Upload KTP
            v-flex(xs6 sm3 class="attachment" v-if="!docPendukung || docPendukung.size > 10000000")
              v-file-input(id="evis-upload-ktp" style="padding-top:15px" :rules="[visitorRules.rules, visitorRules.required]"   label="Hanya 1 file, max 10MB" v-model="docPendukung" accept=".pdf,.png,.jpg,.jpeg")
                template(v-slot:selection="{ text }" )
                  v-chip(small label color="primary" )   {{ text }}
            v-flex(xs6 sm3 class="attachmentName" style="padding-top:15px" v-else)
              span(id="evis-upload-ktp") {{docPendukung.name ? docPendukung.name : docName(docPendukung) }}
              v-btn(icon color="red" @click="deleteDocPendukung('docPendukung')")
                v-icon mdi-close
            v-flex(xs1 sm4)

            v-flex(xs12 sm12)

            v-flex(xs4 sm3 style="padding-top:15px")
              p(class="headerSection") 
                span(class="mustFill") *
                span  Alamat
            v-flex(xs7 sm7 style="padding-top:15px")
              v-text-field(id="evis-visitor-address" class="inputDefault" v-model='visitorAddress' :rules='[visitorRules.required]' label="Alamat")
            v-flex(xs1 sm2)

            
            v-flex(xs4, sm3 style="padding-top:15px" v-if="apd !== 'Tidak' ")
              p(class="headerSection") 
                span(class="mustFill") *
                span  APD Helm
            v-flex(xs7, sm5 style="padding-top:15px" v-if="apd !== 'Tidak' ")
              v-radio-group(id="evis-visitor-apd" v-model="visitorApd.helm", row style="margin-top:-5px" :rules='[visitorRules.required]')
                v-radio(id="evis-visitor-apd" label="Ya", value="Ya")
                v-radio(id="evis-visitor-apd" label="Tidak", value="Tidak")
            v-flex(xs1, sm4 v-if="apd !== 'Tidak' ")

            v-flex(xs4, sm3 style="padding-top:22px" v-if="apd !== 'Tidak' ")
              p(class="headerSection") 
                span(class="mustFill") *
                span  APD Rompi
            v-flex(xs7, sm5 style="padding-top:12px" v-if="apd !== 'Tidak' ")
              v-radio-group(id="evis-apd-rompi" v-model="visitorApd.rompi", row style="margin-top:-5px" :rules='[visitorRules.required]')
                v-radio(id="evis-apd-rompi" label="Ya", value="Ya")
                v-radio(id="evis-apd-rompi" label="Tidak", value="Tidak")
                v-text-field(id="evis-ukuran-rompi" class="inputDefault" v-if="visitorApd.rompi == 'Ya'" v-model='visitorApd.ukuranRompi' label="Ukuran Rompi" :rules='[visitorRules.required]')
                v-text-field(id="evis-ukuran-rompi" class="inputDefault" v-else disabled v-model='visitorApd.ukuranRompi' label="Ukuran Rompi")
            v-flex(xs1, sm4 v-if="apd !== 'Tidak' ")

            v-flex(xs4, sm3 style="padding-top:22px" v-if="apd !== 'Tidak' ")
              p(class="headerSection") 
                span(class="mustFill") *
                span  APD Sepatu
            v-flex(xs7, sm5 style="padding-top:12px" v-if="apd !== 'Tidak' ")
              v-radio-group(id="evis-apd-sepatu" v-model="visitorApd.sepatu", row style="margin-top:-5px" :rules='[visitorRules.required]')
                v-radio(id="evis-apd-sepatu" label="Ya", value="Ya")
                v-radio(id="evis-apd-sepatu" label="Tidak", value="Tidak")
                v-text-field(id="evis-ukuran-sepatu" class="inputDefault" v-if="visitorApd.sepatu == 'Ya'" v-model='visitorApd.ukuranSepatu' label="Ukuran Sepatu" :rules='[visitorRules.required]')
                v-text-field(id="evis-ukuran-sepatu" class="inputDefault" v-else disabled v-model='visitorApd.ukuranSepatu' label="Ukuran Sepatu")
            v-flex(xs1, sm4 v-if="apd !== 'Tidak' ")
            
            v-flex(xs4 sm3 style="padding-top:15px" )
              p(class="headerSection") 
                span(class="mustFill") *
                span  Link Visitor 
            v-flex(xs7 sm7 style="padding-top:15px" )
              a(:href="visitorLink" target="_blank") Link Visitor
            v-flex(xs1 sm2 )
            v-flex(xs4 sm3 style="padding-top:15px" )
              p(class="headerSection") 
                span(class="mustFill") *
                span  Link Induksi 
            v-flex(xs7 sm7 style="padding-top:15px" )
              a(:href="visitorLinkInduksi" target="_blank") Link Induksi
            v-flex(xs1 sm2 )
          
        v-divider
        v-card-actions
          v-spacer
          v-btn(color="primary" text='' style="color:white; width:80px" @click='onClose()')
            | Close
            v-spacer
          v-btn(color='primary'  style="width:120px" @click="handleUpdate"  )  Update
          //- :disabled="!isPageComplete" 
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "EditVisitor",
  props:["dialog","detailVisitor","dataVisitor"],
  data() {
    return {
      golonganDarahList:["A","AB","B","O"],
      visitorName :'',
      status: null,
      ipNo : "",
      visitorId :'',
      visitorPhone:'', 
      errorNotif:'',
      visitorEmail:'',
      apd:'',
      visitorEmergency:'',
      visitorBloodType:'',
      visitorKtp:'',
      valid: true,
      visitorKtpUploadId:null,
      visitorAddress: '',
      visitorLink:'',
      visitorApd :{
        helm: '',
        sepatu:'',
        rompi:'',
        ukuranRompi:'',
        ukuranSepatu :''
      },
            
      docPendukung: null,

      emptyUpload: new File([""], "", {
        type: "",
      }),

    };
  },
  computed: {
    ...mapState(["API_URL", "visitorRules"]),
    isPageComplete: function () {
      return (
        this.visitorEmergency  &&
        this.visitorBloodType &&
        this.visitorKtp &&
        this.visitorKtpUploadId &&
        this.visitorAddress &&
        this.visitorApd 
      );
    },
  },
  mounted() {
  },
  methods: {
    onClose(){
      this.$emit('closeModal', false)
    },
    docName(name) {
      return this.$setFilename(name);
    },
    deleteDocPendukung(name){
      let id = this.visitorKtpUploadId;  
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docPendukung = null;
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    handleUpdate(){
      this.$refs.form.validate();
      if(this.$refs.form.validate() === true) {
        let formData = {
        ipNo : this.ipNo,
        visitorId : this.detailVisitor.id,
        visitorPhone : this.visitorPhone,
        visitorEmergency : this.visitorEmergency,
        visitorBloodType : this.visitorBloodType,
        visitorKtp : this.visitorKtp,
        visitorKtpUploadId : this.visitorKtpUploadId,
        visitorAddress : this.visitorAddress,
        visitorApd : this.visitorApd
      }
      const config = {
        method:  "post",
        url: `${this.API_URL}/v1/requests/editVisitor`,
        headers: {"Content-Type": "application/json", "Authorization": `Bearer ${this.$store.state.token}`},
        data: formData
      };
      axios(config).then(()=> {
        this.$emit('closeModal', false)
        location.reload()
      }).catch(err =>{
        console.log(err.response.data)
      });
      }
    }
  },
  watch: {
    docPendukung(params){
      if(params && params.size < 10000000){
         let formData = new FormData();
          const tempKtpUploadId = Date.now();
          this.visitorKtpUploadId = JSON.stringify(tempKtpUploadId);
        formData.append('uploadId', tempKtpUploadId );
        formData.append('docPendukung', params );
        axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
      }
    },
    detailVisitor(param){
      // console.log(param)
       this.visitorName = param.name
      this.visitorPhone = param.phone
      this.visitorEmail = param.email
      this.visitorLink = param.submitDataUrl
      this.visitorLinkInduksi = param.inductionUrl
      this.visitorEmergency = param.emergencyPhone
      this.visitorBloodType = param.bloodType
      this.visitorKtp = param.ktp
      this.docPendukung = param.ktpImage.docPendukung
      this.visitorAddress = param.address
      this.visitorApd.helm = param.apd.helm
      this.visitorApd.rompi = param.apd.rompi
      this.visitorApd.ukuranRompi = param.apd.ukuranRompi
      this.visitorApd.sepatu = param.apd.sepatu
      this.visitorApd.ukuranSepatu = param.apd.ukuranSepatu
      this.visitorKtpUploadId = param.ktpUploadId;
    },
    dataVisitor(param){
      this.ipNo = param.ipNo
      this.apd = param.ipApd
    },
    visitorEmergency(param){
      if(this.visitorPhone == param){
        this.errorNotif = "No Handphone dan No Darurat tidak boleh sama" 
      }else{
        this.errorNotif = ""
      }
    }
  }
};
</script>

<style>
/* width */

::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #555; 
  border-radius: 10px;
  
}

</style>